import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Workspace from "./pages/Workspace";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Contact from "./pages/Contact";
import Partner from "./pages/Partner";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AuthCallback from "./pages/AuthCallback";
import GoogleRolePicker from "./pages/GoogleRolePicker";
import PolicyPage from "./pages/PolicyPage";
import Careers from "./pages/Careers";
import About from "./pages/About";
import PartnerStudio from "./pages/PartnerStudio";
import PartnerPrinter from "./pages/PartnerPrinter";
import PartnerMaterial from "./pages/PartnerMaterial";
import PartnerLogistics from "./pages/PartnerLogistics";
import PrinterMaterials from "./pages/PrinterMaterials";
import FactoryReset from "./pages/FactoryReset";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { Toaster } from "sonner";
import { SeoManager } from "./components/SeoManager";
import "@/App.css";

function ProtectedRoute({ children, allowRolePending = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return (
      <div className="auth-shell">
        <div className="auth-card"><p className="auth-sub">Checking your session…</p></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (user.role_pending && !allowRolePending) return <Navigate to="/onboarding/role" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton theme="light" toastOptions={{ duration: 4500 }}/>
        <SeoManager/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/partner/studio"    element={<PartnerStudio />} />
          <Route path="/partner/printer"   element={<PartnerPrinter />} />
          <Route path="/partner/material"  element={<PartnerMaterial />} />
          <Route path="/partner/logistics" element={<PartnerLogistics />} />
          <Route path="/materials" element={<Navigate to="/workspace?tab=job-board" replace />} />
          <Route path="/printer/materials" element={<ProtectedRoute><PrinterMaterials /></ProtectedRoute>} />
          <Route path="/admin/factory-reset" element={<ProtectedRoute><FactoryReset /></ProtectedRoute>} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/onboarding/role" element={<ProtectedRoute allowRolePending={true}><GoogleRolePicker /></ProtectedRoute>} />
          <Route path="/workspace" element={<ProtectedRoute><Workspace /></ProtectedRoute>} />
          <Route path="/workspace/*" element={<ProtectedRoute><Workspace /></ProtectedRoute>} />
          {/* Public legal pages */}
          <Route path="/terms"           element={<PolicyPage slug="terms" />} />
          <Route path="/privacy"         element={<PolicyPage slug="privacy" />} />
          <Route path="/escrow-policy"   element={<PolicyPage slug="escrow-policy" />} />
          <Route path="/refund-policy"   element={<PolicyPage slug="refund-policy" />} />
          <Route path="/dispute-policy"  element={<PolicyPage slug="dispute-policy" />} />
          <Route path="/shipping-policy" element={<PolicyPage slug="shipping-policy" />} />
          <Route path="/acceptable-use"  element={<PolicyPage slug="acceptable-use" />} />
          <Route path="/cookie-policy"   element={<PolicyPage slug="cookie-policy" />} />
          <Route path="/policies/:slug"  element={<PolicyPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
